const XLSX = require("xlsx");
const checkValidation = (field, value) => {
  if (field.dataType === "string") {
    const patternString = field.range.replace(/^\/(.+)\/[a-z]*$/i, "$1");
    const regex = new RegExp(patternString);
    const validRange = regex.test(value);
    if (!validRange) {
      if (field.fieldName && field.fieldName.toLowerCase() === "unit serial") {
        return {
          errorMessage: `Invalid input: Use only (A–Z a-z 0–9 _ - )`
        };
      } else {
        return {
          errorMessage: `Invalid input: Use only (A–Z a-z 0–9 _ - *)`,
        };
      }
    }
    return { errorMessage: null };
  } else if (field.dataType === "number") {
    const num = parseInt(value, 10);
    if (isNaN(num) || !Number.isInteger(parseFloat(value))) {
      return { errorMessage: "Must be a whole number" };
    }
    // Continue with range validation like number type
  } else if (field.dataType === "float") {
    const num = parseFloat(value);
    if (isNaN(num)) {
      return { errorMessage: "Must be a valid decimal number" };
    }
    // Continue with range validation like number type  
  }
  
  // Common range validation for number and float
  if (["number", "float"].includes(field.dataType)) {
    let validationRange = field.range;
    if (validationRange.startsWith("'")) {
      validationRange = validationRange.replace(/'/g, '"');
    }
    validationRange = JSON.parse(validationRange);
    const validRange =
      value >= validationRange[0] && value <= validationRange[1];
    return validRange
      ? { errorMessage: null }
      : {
        errorMessage: `Field value should be within the range of ${validationRange[0]} to ${validationRange[1]} ${field.unit}`,
      };
  } else {
    return value
      ? { errorMessage: null }
      : { errorMessage: "Field value cannot be empty" };
  }
};

export const validateForm = (recipeInputFields, userInput, state, jsonByteMatchCount, hasCloneFromId) => {
  const newErrors = {};
  if (state !== "Draft") {
    const userInputLength = hasCloneFromId
      ? (userInput.Reviewer ? Object.keys(userInput).length - 1 - jsonByteMatchCount : Object.keys(userInput).length - jsonByteMatchCount)
      : (userInput.Reviewer ? Object.keys(userInput).length - 1 : Object.keys(userInput).length);    
    const allInputsFilled = recipeInputFields.length === userInputLength;
    if (!allInputsFilled) {
      return { fieldValidation: newErrors, stateValidation: false };
    } else {
      for (const [key] of Object.entries(userInput)) {
        if (!userInput[key] && userInput[key] !== 0) {
          return { fieldValidation: newErrors, stateValidation: false };
        }
      }
    }
  }

  recipeInputFields.forEach((field) => {
    if (userInput[field.fieldName]) {
      const value = userInput[field.fieldName];
      if (!value && value.trim() === "") {
        newErrors[field.id] = "Field value cannot be empty";
      }

      const validation = checkValidation(field, value);
      if (validation.errorMessage) {
        newErrors[field.fieldName] = validation.errorMessage;
      }
    }
  });

  return { fieldValidation: newErrors, stateValidation: true };
};

export const validateSingleField = (field, value) => {
  const validation = checkValidation(field, value);
  return validation.errorMessage || "";
};

export const getCurrentDate = () => {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${day}/${month}/${year}`;

  return currentDate;
};

export const createXLSXSheet = ({
  state,
  productData,
  userInput,
  template,
  payload,
}) => {
  const data = [["Byte Number", "Byte Description", "Value", "Payload"]];
  let byteNumber = 1;
  payload.forEach((arr, idx) => {
    let valueEntered =
      template[idx].type === "static"
        ? template[idx].defaultVal
        : userInput[template[idx].fieldName];
    const description = template[idx].fieldName;
    // if (description === "Shared Data Format Version") {
    //   valueEntered = productData[`${state}Version`];
    // }
    arr.forEach((byte, index) => {
      if (index === 0) data.push([byteNumber, description, valueEntered, byte]);
      else data.push([byteNumber, "", "", byte]);
      byteNumber += 1;
    });
  });
  const workSheet = XLSX.utils.aoa_to_sheet(data);
  workSheet['!cols'] = [
    { wch: data[0][0].length },
    { wch: 58},
    { wch: 17},
    { wch: data[0][3].length },
  ];
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet 1");
  XLSX.writeFile(workBook, `.${productData.ModelNumber}.xlsx`);
};

export const compareByModelNumber = (a, b) => {
  const modelNumberA = a.ModelNumber.toUpperCase();
  const modelNumberB = b.ModelNumber.toUpperCase();
  if (modelNumberA < modelNumberB) {
    return -1;
  } else if (modelNumberA > modelNumberB) {
    return 1;
  } else {
    return 0;
  }
};

export const generateReviewData = (productData, recipeInputFields, recipe) => {
  const result = {
    [productData.ModelNumber]: {...productData}
  };

  // console.log(productData, recipeInputFields, recipe)

  delete result[productData.ModelNumber]["__typename"]
  delete result[productData.ModelNumber]["createdAt"]
  delete result[productData.ModelNumber]["updatedAt"]
  recipe.forEach(item => {
    const { fieldName, part } = item;
    const value = recipeInputFields[fieldName];

    if (!result[productData.ModelNumber][part] && part !== "") {
      result[productData.ModelNumber][part] = {};
    }
  
    if(value) {
        result[productData.ModelNumber][part][fieldName] = value;
    }
  });

  return result;
}

export const getDateString = (date) => {
  if(!date) {
    return "";
  }
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
}

export const int16ToByte = (n) => {
  const bytes = [n & 0xff, (n & 0xff00) >> 8].map((n) =>
    n.toString(16).padStart(2, "0")
  );
  return bytes.toString();
};
